import gql from 'graphql-tag';

















const getFilteredVoiceOverArtistsQuery = gql`
query GetFilteredVoiceOverArtists($filter: FilterOptions) {
  getFilteredVoiceOverArtists(filterOptions: $filter) {
    VoiceOverArtist {
      voiceOverArtistId
      artistName
    }
  }
}
`;

export default (() => ({
  query: getFilteredVoiceOverArtistsQuery,
  module: 'system-asset-library',
  ignoreCache: true,
  buildVariables: (filter) => ({
    filter
  })
}));